import { render, staticRenderFns } from "./backHeader.vue?vue&type=template&id=6cf7b89d&scoped=true&"
import script from "./backHeader.vue?vue&type=script&lang=js&"
export * from "./backHeader.vue?vue&type=script&lang=js&"
import style0 from "./backHeader.vue?vue&type=style&index=0&id=6cf7b89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7b89d",
  null
  
)

export default component.exports